import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { TASK_HEAD_INVESTORS_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateInvestor from './components/CreateInvestor/CreateInvestor';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentInvestor from './interfaces/IMaterialityAssessmentInvestor';

import styles from './scss/MaterialityAssessmentInvestor.module.scss';

function MaterialityAssessmentInvestorView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  investors, onEditRecord, onLoadMore, hasMore, isLoadingMore, onDeleteItem,
  selectedItem, setOpenModal, recordId, currentId, setInvestors, vcmName, vcmId,
  isViewOnly = false,
}: IMaterialityAssessmentInvestor) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantInvestors')}
            buttonTitle={t('materialityAssessment.addInvestor')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyInvestorDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {investors.length > 0 && (
                  <ItemsTable
                    items={investors}
                    headCells={TASK_HEAD_INVESTORS_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateInvestor
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addAnInvestor')}
        selectedItem={selectedItem}
        setOpenModal={setOpenModal}
        recordId={recordId}
        currentId={currentId}
        setInvestors={setInvestors}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentInvestorView;
